module.exports = __webpack_public_path__ + "static/img/Logo_Erasmus.8684f06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logo_Erasmus.png
// module id = fC50
// module chunks = 1